import NotificationsDropdownWrapperMobileContainer from './NotificationsDropdownWrapperMobile.container';
import NotificationsDropdownWrapperMobile from './NotificationsDropdownWrapperMobile';
export default NotificationsDropdownWrapperMobileContainer(NotificationsDropdownWrapperMobile);
//# sourceMappingURL=index.js.map